import { Routes } from '@angular/router';
import { AuthGuard } from './@core/guards';
import {MicrosoftLoginComponent} from "./auth/microsoft-login.component";

export const ROUTES: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/routes').then(m => m.ROUTES),
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/routes').then(m => m.ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'single-pages',
    loadChildren: () => import('./single-pages/routes').then(m => m.ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () => import('./pages/routes').then(m => m.ROUTES),
    canActivate: [AuthGuard],
  },
  { path: '**', redirectTo: '' },
];

export const NOHASHED_ROUTES: Routes = [
  {
    path: 'microsoft-login-callback',
    component: MicrosoftLoginComponent
  }
]
